import {match} from 'ts-pattern';

import {always} from 'ramda';

export function getContentTypeFromImageFileSuffix(suffix?: string | null) {
  return match<string | undefined | null, string | undefined>(suffix)
    .with('jpg', always('image/jpeg'))
    .with('jpeg', always('image/jpeg'))
    .with('png', always('image/png'))
    .with('gif', always('image/gif'))
    .with('webp', always('image/webp'))
    .with('svg', always('image/svg+xml'))
    .otherwise(always(undefined));
}
